import type { To } from 'react-router';
import { useNavigation } from 'react-router';

import type { Props } from '#src/atoms/buttons/Button/index.tsx';
import { Button } from '#src/atoms/buttons/Button/index.tsx';

export const NavigatingButton = ({
  to,
  ...props
}: Omit<Props, 'loading'> & { to: To }) => {
  const navigation = useNavigation();

  return (
    <Button to={to} {...props} loading={navigation.location?.pathname === to} />
  );
};
